import type { GlobalMarketDataShape } from '@blockworks/platform/api/research';

export const prepareGlobalMarketData: (globalMarketHistory: GlobalMarketDataShape[]) => {
    globalMarketData: GlobalMarketDataShape;
    globalMarketChange: number;
    globalMarketVolumeChange: number;
} = (globalMarketHistory: GlobalMarketDataShape[]) => {
    // Fetch global market data for today and yesterday (for 24h change calculations)
    const globalMarketData: GlobalMarketDataShape =
        globalMarketHistory[0] || ({ totalUsdMarketCap: 0, totalUsdVolume24H: 0 } as GlobalMarketDataShape);
    const globalMarketDataYesterday: GlobalMarketDataShape =
        globalMarketHistory[1] || ({ totalUsdMarketCap: 0, totalUsdVolume24H: 0 } as GlobalMarketDataShape);

    const marketCapDelta = globalMarketData.totalUsdMarketCap - globalMarketDataYesterday.totalUsdMarketCap;
    const globalMarketChange = globalMarketDataYesterday.totalUsdMarketCap
        ? (marketCapDelta / globalMarketDataYesterday.totalUsdMarketCap) * 100
        : 0;

    const marketVolumeDelta = globalMarketData.totalUsdVolume24H - globalMarketDataYesterday.totalUsdVolume24H;
    const globalMarketVolumeChange = globalMarketDataYesterday.totalUsdVolume24H
        ? (marketVolumeDelta / globalMarketDataYesterday.totalUsdVolume24H) * 100
        : 0;

    return {
        globalMarketData,
        globalMarketChange,
        globalMarketVolumeChange,
    };
};
